import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

export default function Legal() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PublicHeader />
      <section className="max-w-3xl mx-auto px-6 py-20" data-testid="legal-page">
        <span className="overline">Informations légales</span>
        <h1 className="font-display text-5xl font-medium tracking-tighter mt-4 mb-12">Mentions légales & RGPD</h1>

        <article className="prose prose-zinc max-w-none">
          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">Éditeur</h2>
          <p className="text-zinc-700 leading-relaxed">
            <strong>FlowMind AI SAS</strong>, société par actions simplifiée au capital de 10 000 €,
            immatriculée au RCS de Paris sous le numéro SIREN 000 000 000.
            Siège social : 1 rue de Rivoli, 75001 Paris, France.
            Directeur de la publication : La direction de FlowMind AI.
            Contact : contact@flowmindai.eu
          </p>

          <h2 id="rgpd" className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">RGPD — Protection des données</h2>
          <p className="text-zinc-700 leading-relaxed">
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique & Libertés,
            FlowMind AI s'engage à :
          </p>
          <ul className="list-disc pl-6 text-zinc-700 space-y-2 mt-3">
            <li>Stocker l'ensemble des données utilisateurs <strong>exclusivement dans des datacenters situés en Union Européenne</strong> (région eu-west-3, Paris).</li>
            <li>Ne jamais transférer vos données vers des pays tiers sans garanties appropriées.</li>
            <li>Permettre l'accès, la rectification, l'effacement et la portabilité des données à tout moment.</li>
            <li>Notifier toute violation de données dans un délai maximum de 72 heures.</li>
            <li>Ne stocker que les données strictement nécessaires au service.</li>
          </ul>
          <p className="text-zinc-700 leading-relaxed mt-4">
            Pour exercer vos droits ou contacter notre DPO : <strong>dpo@flowmindai.eu</strong>
          </p>

          <h2 id="cgu" className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">Conditions générales d'utilisation</h2>
          <p className="text-zinc-700 leading-relaxed">
            L'utilisation du service FlowMind AI implique l'acceptation pleine et entière des présentes CGU.
            Toute automatisation créée via la plateforme reste la propriété de son auteur. FlowMind AI n'exploite
            jamais le contenu des workflows à des fins publicitaires ou d'entraînement de modèles IA tiers.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">Cookies</h2>
          <p className="text-zinc-700 leading-relaxed">
            FlowMind AI utilise uniquement des cookies techniques indispensables au fonctionnement du service.
            Aucun cookie tiers de tracking publicitaire n'est déposé.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">Hébergement</h2>
          <p className="text-zinc-700 leading-relaxed">
            Site et services hébergés au sein de l'Union Européenne. Infrastructure certifiée ISO 27001.
          </p>
        </article>
      </section>
      <PublicFooter />
    </div>
  );
}
